(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["heartz-bundle-experience"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-heartz-bundle]');
    if (!root) return;

    const pageType = root.dataset.pageType;
    if (pageType === 'collection') document.documentElement.classList.add('heartz-bundle-collection');
    const collectionUrl = root.dataset.collectionUrl;
    const cartUrl = root.dataset.cartUrl;
    const rootUrl = root.dataset.rootUrl.replace(/\/?$/, '/');
    const addedText = root.dataset.addedText;
    const status = root.querySelector('[data-heartz-status]');
    const detail = root.querySelector('[data-heartz-detail]');
    const meter = root.querySelector('[data-heartz-meter]');
    const cta = root.querySelector('[data-heartz-cta]');
    const toast = root.querySelector('[data-heartz-toast]');
    const productFilters = root.querySelector('[data-heartz-product-filters]');
    let toastTimer;

    const isShirt = (item) => /shirt/i.test(item.product_title || '') || /shirt/i.test(item.product_type || '');
    const shirtQuantity = (cart) => cart.items.reduce((total, item) => total + (isShirt(item) ? item.quantity : 0), 0);
    const cartEndpoint = `${rootUrl}cart.js`;
    const addEndpoint = `${rootUrl}cart/add.js`;

    const showToast = (message) => {
      if (!toast) return;
      toast.textContent = message;
      toast.classList.add('is-visible');
      window.clearTimeout(toastTimer);
      toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 2600);
    };

    const renderProgress = (quantity) => {
      const capped = Math.min(quantity, 15);
      const completed = capped > 0 && capped % 5 === 0;
      const nextBundle = capped < 5 ? 5 : capped < 10 ? 10 : 15;
      const remaining = completed ? 0 : Math.max(nextBundle - capped, 0);
      const currentStep = completed ? 5 : capped % 5;
      const bundlePrice = nextBundle * 30;

      meter.style.width = `${Math.min((currentStep / 5) * 100, 100)}%`;

      if (quantity === 0) {
        status.textContent = 'Choose your 5 T-shirts';
        detail.textContent = 'Mix styles and sizes · €150 shipping included';
        cta.textContent = 'Start choosing';
        cta.href = collectionUrl;
        return;
      }

      if (quantity > 15) {
        status.textContent = `${quantity} T-shirts selected`;
        detail.textContent = 'Maximum 15 T-shirts per order';
        cta.textContent = 'View cart';
        cta.href = cartUrl;
        meter.style.width = '100%';
        return;
      }

      if (completed) {
        status.textContent = `${quantity} selected · €${quantity * 30}`;
        detail.textContent = 'Bundle unlocked · shipping included';
        cta.textContent = 'View cart';
        cta.href = cartUrl;
        meter.style.width = '100%';
        return;
      }

      status.textContent = `${quantity} selected · add ${remaining} more`;
      detail.textContent = `${nextBundle} T-shirts for €${bundlePrice} · shipping included`;
      cta.textContent = pageType === 'collection' ? 'Keep choosing' : 'Add shirts';
      cta.href = collectionUrl;
    };

    const refreshCart = async () => {
      const response = await fetch(`${cartEndpoint}?_=${Date.now()}`, {
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      renderProgress(shirtQuantity(cart));
      document.querySelectorAll('.thb-item-count').forEach((badge) => {
        badge.textContent = cart.item_count;
        badge.style.display = cart.item_count > 0 ? '' : 'none';
      });
      return cart;
    };

    const enhancePhotoPreviews = (() => {
      if (pageType !== 'collection') return () => {};

      const mobile = window.matchMedia('(max-width: 749px), (hover: none) and (pointer: coarse)');
      const records = new Map();

      const paint = (record) => {
        record.card.classList.toggle('heartz-photo-active', mobile.matches && record.ready && record.wanted);
      };

      const loadPhoto = (record) => {
        const image = record.image;
        if (image.dataset.srcset && !image.srcset) image.srcset = image.dataset.srcset;
        if (image.dataset.src && !image.getAttribute('src')) image.src = image.dataset.src;
        if (!record.loading) {
          record.loading = true;
          image.sizes = `${Math.ceil(record.link.getBoundingClientRect().width)}px`;
          image.loading = 'eager';
        }
        if (image.complete && image.naturalWidth > 40) {
          record.ready = true;
          paint(record);
        }
      };

      const reset = (record) => {
        record.touching = false;
        record.wanted = false;
        paint(record);
      };

      const preloadObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const record = records.get(entry.target.closest('product-card'));
          if (entry.isIntersecting && record && mobile.matches) loadPhoto(record);
        });
      }, { rootMargin: '300px 0px' }) : null;

      mobile.addEventListener('change', () => {
        records.forEach((record) => {
          reset(record);
          record.card.classList.toggle('heartz-photo-mobile', mobile.matches);
        });
      });
      window.addEventListener('blur', () => records.forEach(reset));

      return () => {
        records.forEach((record, card) => {
          if (card.isConnected) return;
          reset(record);
          preloadObserver?.unobserve(record.link);
          records.delete(card);
        });
        document.querySelectorAll('#product-grid product-card').forEach((card) => {
          if (records.has(card)) return;
          const link = card.querySelector('.product-featured-image-link');
          const image = link?.querySelector('.product-secondary-image');
          if (!link || !image) return;
          const record = { card, link, image, ready: false, wanted: false, touching: false, loading: false };
          records.set(card, record);
          card.classList.add('heartz-photo-managed');
          card.classList.toggle('heartz-photo-mobile', mobile.matches);
          image.addEventListener('load', () => loadPhoto(record));
          image.addEventListener('error', () => {
            record.ready = false;
            reset(record);
          });
          link.addEventListener('pointerdown', (event) => {
            if (event.pointerType === 'mouse' || event.isPrimary === false || !mobile.matches) return;
            record.touching = true;
            record.wanted = true;
            loadPhoto(record);
            paint(record);
          }, { passive: true });
          link.addEventListener('pointermove', (event) => {
            if (!record.touching || event.isPrimary === false) return;
            const bounds = link.getBoundingClientRect();
            record.wanted = event.clientX >= bounds.left && event.clientX <= bounds.right && event.clientY >= bounds.top && event.clientY <= bounds.bottom;
            paint(record);
          }, { passive: true });
          ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((name) => {
            link.addEventListener(name, () => reset(record), { passive: true });
          });
          preloadObserver?.observe(link);
        });
      };
    })();

    const enhanceCards = () => {
      if (pageType !== 'collection') return;
      document.querySelectorAll('product-card').forEach((card) => {
        card.querySelectorAll('.swatch-wrap a').forEach((link) => {
          const option = link.querySelector('.individual-option');
          if (!option) return;
          if (option.classList.contains('out-of-stock-option')) {
            link.setAttribute('aria-disabled', 'true');
            link.setAttribute('tabindex', '-1');
          } else {
            const productTitle = card.querySelector('.product-card-title')?.textContent?.trim() || 'T-shirt';
            const size = option.childNodes[0]?.textContent?.trim() || option.textContent.trim();
            link.setAttribute('aria-label', `Add ${productTitle}, size ${size}, to cart`);
            link.dataset.heartzQuickAdd = 'true';
          }
        });
      });
    };

    const placeIntro = () => {
      const intro = root.querySelector('[data-heartz-intro]');
      const grid = document.querySelector('#ProductGridContainer');
      if (intro && grid && intro.parentElement !== grid.parentElement) grid.insertAdjacentElement('beforebegin', intro);
    };

    const placeProductFilters = () => {
      const grid = document.querySelector('#ProductGridContainer');
      if (productFilters && grid && productFilters.parentElement !== grid.parentElement) grid.insertAdjacentElement('beforebegin', productFilters);
    };

    const addProductMarker = () => {
      if (root.dataset.productEligible !== 'true') return;
      document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
        if (form.querySelector('[name="properties[_24heartz_bundle]"]')) return;
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'properties[_24heartz_bundle]';
        input.value = '5-shirts-150';
        form.appendChild(input);
      });
    };

    const addTrustRows = () => {
      if (pageType !== 'cart') return;
      document.querySelectorAll('.cart-drawer-buttons, .proceed-to-checkout, .cart-footer').forEach((target) => {
        if (target.querySelector('.heartz-trust-row')) return;
        const row = document.createElement('div');
        row.className = 'heartz-trust-row';
        ['Shipping included', 'Secure payment', 'WhatsApp support'].forEach((text) => {
          const item = document.createElement('span');
          item.textContent = text;
          row.appendChild(item);
        });
        target.appendChild(row);
      });
    };

    document.addEventListener('click', async (event) => {
      const link = event.target.closest('[data-heartz-quick-add="true"]');
      if (!link || pageType !== 'collection') return;
      const option = link.querySelector('.individual-option');
      if (!option || option.classList.contains('out-of-stock-option')) return;

      const variantId = new URL(link.href, window.location.origin).searchParams.get('variant');
      if (!variantId) return;

      event.preventDefault();
      if (link.classList.contains('heartz-is-adding')) return;
      link.classList.add('heartz-is-adding');

      try {
        const response = await fetch(addEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{
              id: Number(variantId),
              quantity: 1,
              properties: { _24heartz_bundle: '5-shirts-150' }
            }]
          })
        });
        if (!response.ok) throw new Error('Add failed');
        showToast(addedText);
        await refreshCart();
        document.dispatchEvent(new CustomEvent('cart:item-added'));
      } catch (error) {
        showToast('Could not add this size. Please try again.');
      } finally {
        link.classList.remove('heartz-is-adding');
      }
    });

    document.addEventListener('cart:item-added', () => window.setTimeout(refreshCart, 180));
    document.addEventListener('line-item:change:end', () => window.setTimeout(refreshCart, 180));

    const updateFilterLinks = () => {
      if (!productFilters) return;
      const params = new URLSearchParams(window.location.search);
      params.delete('page');
      productFilters.querySelectorAll('.heartz-filter-option').forEach((link) => {
        const target = new URL(link.href, window.location.origin);
        target.search = params.toString();
        if (link.href !== target.href) link.href = target.href;
      });
    };

    productFilters?.addEventListener('pointerdown', updateFilterLinks);
    productFilters?.addEventListener('focusin', updateFilterLinks);

    const observer = new MutationObserver(() => {
      enhanceCards();
      enhancePhotoPreviews();
      addProductMarker();
      addTrustRows();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    placeIntro();
    placeProductFilters();
    enhanceCards();
    enhancePhotoPreviews();
    updateFilterLinks();
    addProductMarker();
    addTrustRows();
    refreshCart().catch(() => {});
  })();

  } catch(e) { console.error(e); }
})();
})();
